// Loads a remote image into the browser cache ahead of render, so a card can
// hold its pending skeleton until its art is paintable — the same contract a
// native BifrostImage gives a tree card for free. Rejects on a load failure;
// the caller decides what that means for the product. Kept as its own module
// so tests can stand in for the browser's image loading, which happy-dom
// never performs.
export function preloadImage(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.onload = () => resolve()
    image.onerror = () => reject(new Error(`image failed to load: ${src}`))
    image.src = src
  })
}
